/** `uiStore`が保持する値と1対1で対応する、永続化対象の設定一式（帳・O-1）。 */
export interface Settings {
  readonly volume: number;
  /** 囃子（BGM）のミュート。既定`true`（既定でfetchしない。NFR-003）。 */
  readonly muted: boolean;
  readonly mobileGuideAcknowledged: boolean;
  readonly narrationSpeedMultiplier: number;
  readonly reduceMotionOverride: boolean;
}

export function createSettings(): Settings {
  return {
    volume: 1,
    muted: true,
    mobileGuideAcknowledged: false,
    narrationSpeedMultiplier: 1,
    reduceMotionOverride: false,
  };
}
